import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = { role: ROLE.SUPER_ADMIN };

const path = "admin/photoroom-usage";

export const List = async (values) => {
  return await axiosInstance(options).post(`${path}/list`, values);
};
